import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { currentUserSelector, useAppStore } from 'stores/appStore';

const useStyles = makeStyles()((theme) => ({
  root: {
    boxShadow: 'none',
  },
  logo: {
    width: '50px',
    borderRadius: '50%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: process.env.REACT_APP_STAGE
      ? `linear-gradient(45deg, rgb(183 26 26) 0%, #e58221 20%, #8C21E5  100%)`
      : `linear-gradient(45deg, ${darken('#5721E5', 0.2)} 0%, #5721E5 20%, ${darken('#8C21E5', 0.1)}  100%)`,
    // boxShadow:
    //   '2px 0px 1px -1px rgb(0 0 0 / 20%), 1px 0px 1px 0px rgb(0 0 0 / 14%), 1px 0px 3px 0px rgb(0 0 0 / 12%',
  },
  flexGrow: {
    flexGrow: 1,
  },
  name: {
    color: '#ffffffd4',
    padding: '0px 10px',
    marginBottom: '5px',
    fontSize: '16px',
  },
  userWelcomeMsg: {
    color: '#fff',
    padding: '0px 10px',
    marginBottom: '5px',
    fontSize: '16px',
  },
  buttonNav: {
    color: '#ffffffd4',
  },
}));

const Topbar = (props) => {
  const { className, showLoginBtn, showUserWelcomeMsg, ...rest } = props;
  const currentUser = useAppStore(currentUserSelector);

  const { classes } = useStyles();

  return (
    <AppBar {...rest} className={classes.appBar} color="primary" position="fixed">
      <Toolbar>
        <RouterLink to="/">
          <img alt="Logo" src="/images/logos/minha-agenda-logo-white-small.png" className={classes.logo} />
        </RouterLink>
        <RouterLink to="/">
          <Typography className={classes.name} variant="h5">
            MinhaAgenda
          </Typography>
        </RouterLink>
        <div className={classes.flexGrow} />
        {/* {showLoginBtn && (
          <Button variant="outlined" className={classes.buttonNav} component={RouterLink} to={'/agenda'}>
            Entrar
          </Button>
        )} */}
        {showUserWelcomeMsg && currentUser?.principal?.name && (
          <Typography variant="subtitle1" className={classes.userWelcomeMsg}>
            Olá, {currentUser.principal.name}
          </Typography>
        )}
      </Toolbar>
    </AppBar>
  );
};

Topbar.defaultProps = {
  showLoginBtn: true,
  showUserWelcomeMsg: false,
};
Topbar.propTypes = {
  className: PropTypes.string,
  showLoginBtn: PropTypes.bool,
  showUserWelcomeMsg: PropTypes.bool,
};

export default Topbar;
